export { anatomy } from "./checkbox.anatomy"
export { connect } from "./checkbox.connect"
export { machine } from "./checkbox.machine"
export type { CheckedState, UserDefinedContext as Context, MachineApi as Api } from "./checkbox.types"
